module.exports = __webpack_public_path__ + "static/image/live_static.svg?fe63d4583549594e25d79e2f6e552943";